import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { IoChevronBack, IoNotificationsOutline, IoChatbubbleEllipsesOutline } from 'react-icons/io5';
import ieumLogo from '../../assets/ieum-logo.png';

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 16px;
  background: white;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  z-index: 50;

  @media (min-width: 1281px) {
    position: sticky;
    left: auto;
    transform: none;
    max-width: none;
  }
`;

const LeftArea = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const BackBtn = styled.button`
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  align-items: center;
  padding: 8px 4px 8px 0;
  min-width: 32px;
  min-height: 44px;
`;

const Title = styled.p`
  font-size: 17px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
`;

const HeaderLogo = styled.img`
  width: 28px;
  height: 28px;
  object-fit: contain;
  margin-left: 4px;
`;

const IconRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const IconBtn = styled.button`
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  align-items: center;
  padding: 8px 6px;
  position: relative;
  min-width: 36px;
  min-height: 44px;
`;

const BadgeDot = styled.span`
  position: absolute;
  top: 6px;
  right: 2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #EF4444;
`;

// 서브페이지 제목 매핑
const PAGE_TITLES = {
  '/realtor': '이음',
  '/realtor/recommend': '고객 초대',
  '/realtor/recommend/customer': '고객 초대',
  '/realtor/recommend/realtor': '중개사 초대',
  '/realtor/recommend/qr': '전용 QR 코드',
  '/realtor/manage': '관리·정산',
  '/realtor/manage/customer': '고객 DB 추적',
  '/realtor/manage/lead': '리드 관리',
  '/realtor/manage/prospect': '가망고객 등록',
  '/realtor/manage/referral': '추천 현황',
  '/realtor/manage/settlement': '정산 현황',
  '/realtor/manage/referral-members': '추천 가입회원내역 조회',
  '/realtor/manage/settlement-check': '정산 확인',
  '/realtor/manage/track-history': '고객 DB 추적 현황 내역',
  '/realtor/mypage': '마이페이지',
  '/realtor/mypage/profile': '프로필 수정',
  '/realtor/mypage/edit': '프로필 편집',
  '/realtor/mypage/account': '계좌 인증',
  '/realtor/mypage/notification': '알림 설정',
  '/realtor/mypage/withdraw': '리워드 수익금 출금 신청',
  '/realtor/mypage/withdraw-history': '출금 내역',
  '/realtor/mypage/commission': '리워드 적립 내역',
  '/realtor/mypage/stats': '실적/통계',
  '/realtor/mypage/performance': '실적',
  '/realtor/mypage/reward-stats': '리워드 내역 조회',
  '/realtor/mypage/customer-db-stats': '고객 DB 실적 통계',
  '/realtor/mypage/faq': '도움말',
  '/realtor/mypage/notice': '공지사항',
  '/realtor/notifications': '알림',
  '/realtor/inquiry': '관리자 문의',
  '/realtor/inquiry/new': '문의 작성',
};

const ROOT_PATHS = ['/realtor', '/realtor/recommend', '/realtor/manage', '/realtor/mypage'];

const AppHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const title = PAGE_TITLES[path] || '이음';
  const isRoot = ROOT_PATHS.includes(path);

  // 홈/추천 페이지에서는 AppHeader 숨김 (자체 헤더 사용)
  if (path === '/realtor') return null;
  if (path.startsWith('/realtor/recommend')) return null;
  if (['/realtor/manage/referral', '/realtor/manage/settlement'].includes(path)) return null;

  return (
    <Header>
      <LeftArea>
        {!isRoot && (
          <BackBtn onClick={() => navigate(-1)}>
            <IoChevronBack size={22} />
          </BackBtn>
        )}
        {isRoot && <HeaderLogo src={ieumLogo} alt="이음" />}
        <Title>{title}</Title>
      </LeftArea>
      {isRoot && path !== '/realtor/mypage' && path !== '/realtor/manage' && (
        <IconRow>
          <IconBtn onClick={() => navigate('/realtor/notifications')}>
            <IoNotificationsOutline size={22} />
            <BadgeDot />
          </IconBtn>
          <IconBtn onClick={() => navigate('/realtor/inquiry')}>
            <IoChatbubbleEllipsesOutline size={20} />
          </IconBtn>
        </IconRow>
      )}
    </Header>
  );
};

export default AppHeader;
